export const Footer = (props) => {
  
  return (
    <div style={{margin:"0"}}>
      <div id='footer' style={{padding:"0rem"}}>
        <div className='container text-center' style={{ backgroundColor:'#2c2d31' ,width:'100%', height:'6%' , position:'absolute' ,margin:"0rem" }}>
          <p style={{ color:'white',  margin:'1rem' }}>
            &copy; Copyright MNNIT 2025. All right Reserved by MNNIT Allahabad. Developed by <a href="https://www.linkedin.com/in/hardik-kumar-singh/" target="_blank" rel="noreferrer" style={{ color:'yellow' }}>Hardik Kumar Singh</a>
          </p>
        </div>
      </div>
    </div>
  )
}
